const ALL_FLAGS = [] as const;

export default class ServerFeatureFlags {
  static readonly NAMES = ALL_FLAGS;

  constructor(dto: ServerFeatureFlagsDto) {
    Object.assign(this, dto);
  }

  getFlag(flag: ServerFeatureFlagName): boolean {
    return Boolean(this[flag]);
  }
}

export type ServerFeatureFlagName = (typeof ALL_FLAGS)[number];
export type ServerFeatureFlagsDto = {
  [Flag in ServerFeatureFlagName]?: boolean;
};
